import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/useAuth";

export function PrivateRoute({ children }) {
  const { user, loadingAuth } = useAuth();

  if (loadingAuth) return null;

  return user ? children : <Navigate to="/login" replace />;
}

